import styles from "../../pages/Community/CreateCommunityPage.module.css";

const SectionsManager = ({
  filteredSections,
  searchText,
  setSearchText,
  newSection,
  setNewSection,
  selectedSectionIds,
  editingSectionId,
  editingSectionTitle,
  setEditingSectionTitle,
  isCreatingSection,
  isRenamingSection,
  deletingSectionId,
  isSubmitting,
  handleCheckboxChange,
  handleCreateSection,
  handleStartEdit,
  handleCancelEdit,
  handleSaveRename,
  handleDeleteSection,
}) => {
  return (
    <div className={styles.sectionsWrapper}>
      <label className={styles.inlineLabel}>Sections List</label>
      <div className={styles.sectionsCard}>
        <div className={styles.searchBar}>
          <input
            type="text"
            placeholder="type in to Filter sections"
            className={styles.searchInput}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            disabled={isSubmitting}
          />
          <span className={styles.searchIcon}>🔍</span>
        </div>

        <div className={styles.sectionList}>
          {filteredSections.map((section) => (
            <div className={styles.sectionRow} key={section.id}>
              {editingSectionId === section.id ? (
                <div className={styles.editSectionContainer}>
                  <input
                    type="text"
                    value={editingSectionTitle}
                    onChange={(e) => setEditingSectionTitle(e.target.value)}
                    className={styles.editSectionInput}
                    disabled={isRenamingSection}
                    autoFocus
                  />
                  <div className={styles.editActions}>
                    <button
                      className={styles.saveButton}
                      onClick={() => handleSaveRename(section.id)}
                      disabled={
                        isRenamingSection || !editingSectionTitle.trim()
                      }
                    >
                      {isRenamingSection ? "⟳" : "✓"}
                    </button>
                    <button
                      className={styles.cancelButton}
                      onClick={handleCancelEdit}
                      disabled={isRenamingSection}
                    >
                      ✕
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <span className={styles.sectionLabel}>{section.title}</span>
                  <div className={styles.sectionActions}>
                    <button
                      className={styles.editIconButton}
                      onClick={() => handleStartEdit(section)}
                      disabled={
                        isSubmitting || deletingSectionId === section.id
                      }
                      title="Rename section"
                    >
                      ✎
                    </button>
                    <button
                      className={styles.deleteIconButton}
                      onClick={() => handleDeleteSection(section.id)}
                      disabled={
                        isSubmitting || deletingSectionId === section.id
                      }
                      title="Delete section"
                    >
                      {deletingSectionId === section.id ? "⟳" : "🗑"}
                    </button>
                    <input
                      type="checkbox"
                      className={styles.checkbox}
                      checked={selectedSectionIds.includes(section.id)}
                      onChange={() => handleCheckboxChange(section)}
                      disabled={
                        isSubmitting || deletingSectionId === section.id
                      }
                    />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>

        <div className={styles.addSection}>
          <input
            type="text"
            placeholder="Add new section here"
            value={newSection}
            onChange={(e) => setNewSection(e.target.value)}
            className={styles.addInputNewSection}
            disabled={isCreatingSection || isSubmitting}
          />
          <button
            className={`${styles.addButton} ${
              isCreatingSection ? styles.loading : ""
            }`}
            onClick={handleCreateSection}
            disabled={isCreatingSection || isSubmitting || !newSection.trim()}
          >
            {isCreatingSection ? "⟳" : "+"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SectionsManager;
